<template>
  <div class="AdelantosNominaValidar">
    <md-card class="m-t-24">
      <md-card-header>
        <div class="md-title">Validación de adelantos de nómina</div>
        <div class="md-subhead">Conforme vaya realizando los cambios, estos se irán guardando automáticamente</div>
      </md-card-header>
      <md-table>
        <md-table-header>
          <md-table-row>
            <md-table-head> # emp </md-table-head>
            <md-table-head> Nombre </md-table-head>
            <md-table-head> Puesto </md-table-head>
            <md-table-head> Punto </md-table-head>
            <md-table-head> Sal. Qnal </md-table-head>
            <md-table-head> Solicitado </md-table-head>
            <md-table-head> </md-table-head>
          </md-table-row>
        </md-table-header>
        <md-table-body>
          <md-table-row v-for="adelanto in adelantos" :key="adelanto.id_emn_ano">
            <md-table-cell> {{adelanto.id_emn}} </md-table-cell>
            <md-table-cell> {{adelanto.nombre_empleado}} </md-table-cell>
            <md-table-cell> {{adelanto.nombre_pue}}</md-table-cell>
            <md-table-cell> {{adelanto.nombre_pun}}</md-table-cell>
            <md-table-cell> {{nF(adelanto.salario_qnal_pnh)}} </md-table-cell>
            <md-table-cell> {{nF(adelanto.solicito_ano)}} </md-table-cell>
            <md-table-cell>
              <md-input-container>
                <md-icon>attach_money</md-icon>
                <label>Importe</label>
                <md-input style="width:auto!important" type="number" min="0" :max="adelanto.salario_qnal_pnh" v-model="adelanto.autorizado_ano" placeholder="Autorizado" @blur="guardarCambiosAdelanto(adelanto,$event)"></md-input>
              </md-input-container>
            </md-table-cell>
          </md-table-row>
        </md-table-body>
      </md-table>
      <md-card-actions>
        <md-button class="md-raised md-primary" @click.native="obtenerAdelantosRegistrados()">Actualizar contenido</md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
export default {
  name: "AdelantosNominaValidar",
  methods: {
    nF(numerito) {
      return Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN"
      }).format(numerito);
    },
    obtenerAdelantosRegistrados() {
      this.$http
        .post("adelantos", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "adelantos" in response.body) {
              this.adelantos = response.body.adelantos;
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    guardarCambiosAdelanto(a, e) {
      if (a.autorizado_ano >= a.salario_qnal_pnh / 2) {
        Snackbar.show({
          text:
            "El adelanto de nómina autorizado para " +
            a.nombre_empleado +
            " es mayor a la mitad de su salario quincenal",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: true,
          backgroundColor: "#FFC107",
          textColor: "#000",
          actionTextColor: "#000"
        });
      }
      //id_ano, solicito_ano, autorizado_ano, empleado, nombre_empleado, nombre_pue, depto_pue, salario_qnal_pnh
      this.$http
        .post("adelantos/actualizar", {
          token: this.$session.get("token"),
          data: {
            adelanto: sha1(md5(a.id_ano)),
            autorizado: a.autorizado_ano
          }
        })
        .then(
          response => {},
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerAdelantosRegistrados();
  },
  data() {
    return {
      msg: "AdelantosNominaValidar",
      adelantos: []
    };
  }
};
</script>


// WEBPACK FOOTER //
// AdelantosNominaValidar.vue?0561af44